import { appThemeColors } from "styles/appTheme";
import { appThemeRadius, appThemeSize } from "styles/appThemeTokens";

export const SIDE_DRAWER_UI = {
  closeAriaLabel: "Close",
  cancelLabel: "Cancel",
  submitLabel: "Save",
};

export const SIDE_DRAWER_WIDTH = "min(520px, 100vw)";

const headerOffset = appThemeSize.headerHeight;

export const sideDrawerRootSx = {
  zIndex: 1300,
};

export const sideDrawerPaperSx = {
  width: SIDE_DRAWER_WIDTH,
  maxWidth: "100vw",
  top: headerOffset,
  height: `calc(100% - ${headerOffset}px)`,
  boxShadow: "none",
  borderLeft: `1px solid ${appThemeColors.border.default}`,
  backgroundColor: appThemeColors.background.paper,
};

export const sideDrawerBackdropSx = {
  top: headerOffset,
  height: `calc(100% - ${headerOffset}px)`,
  backgroundColor: "rgba(10,31,58,.42)",
};

export { appThemeColors, appThemeRadius };
